module.exports = __webpack_public_path__ + "static/Photo2-97ebe0f90359898ae810cebb60725cbd.jpg";